/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Snackbar,
  Avatar,
  Checkbox,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Button,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { GrTrash } from '@react-icons/all-files/gr/GrTrash';
import ClassNames from 'classnames';

const { selectCurrentCountry } = Slices.profileSlice;
const { selectBaseURL, selectCountryValidations, getDecimalPoints } = Slices.configSlice;
const { selectProductEntities } = Slices.productSlice;
import ProductConfigurableRadio from '../ProductConfigurableRadio';
import css from './index.module.scss';
const { updateProductPayload } = Slices.tempCartSlice;
import { subProductsGA } from 'spwa-ui-library/esm/utils/helperGA';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { useLocation } from '@reach/router';

export default function ProductOptionCheckbox({
  mainItem,
  option,
  type,
  id,
  onChange,
  optionId,
  checked,
  bundlePosition,
  selectedProduct,
  productID,
  disabled,
  maximum,
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [radioChecked, setRadioChecked] = useState(-1);
  const [alertMessage, setAlertMessage] = useState('');
  const [check, setChecked] = useState((option?.selected || option?.selectionQty) > 0);
  const isDesktop = useSelector(selectDesktop);
  const productsMap = useSelector(selectProductEntities);
  const tempItems = useSelector((state) => state.tempCart);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const decimalPoints = useSelector(getDecimalPoints);
  const sub = [];

  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product');
  const stepId = locationSearch.get('step');

  const productCustomization = tempItems.data?.items?.find(
    (product) => product.id == (isBundleItem ? mainProductId : productID)
  );

  const defaultSubOptions = option?.subOptions?.filter((subOption) => subOption?.default === 1);

  let isAnySubOptionSelected;

  if (isBundleItem) {
    isAnySubOptionSelected =
      productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[bundlePosition]?.[
        option.id
      ]?.['qty'] &&
      productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[bundlePosition]?.[
        option.id
      ]?.['qty'] > 0;
  } else {
    isAnySubOptionSelected =
      productCustomization?.items?.[optionId]?.[option.id]?.['qty'] &&
      productCustomization?.items?.[optionId]?.[option.id]?.['qty'] > 0;
  }

  function setNestedProperty(obj, keys, value) {
    // let currentObj = obj;
    // for (let i = 0; i < keys.length - 1; i++) {
    //   const key = keys[i];
    //   currentObj[key] = currentObj[key] || {};
    // }
    // currentObj[keys[keys.length - 1]] = value;
  }
  const handleAlertClose = (event, reason) => {
    setAlertMessage('');
  };

  const handleChangeRadio = (value, condimentsItems, action) => {
    let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

    if (isBundleItem) {
      if (
        !newProductCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[bundlePosition]?.[
          option.id
        ]
      ) {
        setNestedProperty(
          newProductCustomization,
          ['bundle', stepId, productID, 'items', bundlePosition, optionId],
          {}
        );
      }

      if (
        !newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][option.id]
      ) {
        newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][
          option.id
        ] = {};
      }

      if (
        (newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][option.id]['qty'] || 0) <= 1
      ) {
        if (disabled) {
          setAlertMessage(
            intl.formatMessage({ id: 'max_quantity_allowed_for_this_step' }, { count: maximum })
          );
          return;
        }
        newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][option.id][
          'qty'
        ] =
          (newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][
            option.id
          ]?.['qty'] || 0) + 1;
      } else {
        newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][option.id][
          'qty'
        ] =
          (newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][
            option.id
          ]?.['qty'] || 2) - 1;
      }
    } else {
      if (!newProductCustomization?.items) {
        newProductCustomization['items'] = {};
      }
      if (!newProductCustomization.items?.[optionId]) {
        newProductCustomization.items[optionId] = {};
      }
      if (!newProductCustomization.items?.[optionId]?.[option.id]) {
        newProductCustomization.items[optionId][option.id] = {};
      }

      if ((newProductCustomization.items[optionId][option.id]['qty'] || 0) <= 1) {
        if (disabled) {
          setAlertMessage(
            intl.formatMessage({ id: 'max_quantity_allowed_for_this_step' }, { count: maximum })
          );
          return;
        }
        newProductCustomization.items[optionId][option.id]['qty'] =
          (newProductCustomization.items[optionId][option.id]?.qty || 0) + 1;
      } else {
        newProductCustomization.items[optionId][option.id]['qty'] =
          (newProductCustomization.items[optionId][option.id]?.qty || 2) - 1;
      }
    }

    if (action === 'select') {
      if (!newProductCustomization?.added) {
        newProductCustomization.added = {};
        newProductCustomization.added[option.id] = `${option?.title} (${condimentsItems?.title})`;
        if (
          newProductCustomization?.removed &&
          newProductCustomization.removed[option.id] !== undefined
        ) {
          delete newProductCustomization?.removed[option.id];
        }
      } else {
        newProductCustomization.added[option?.id] = `${option?.title} (${condimentsItems?.title})`;
        if (
          newProductCustomization?.removed &&
          newProductCustomization?.removed[option.id] !== undefined
        ) {
          delete newProductCustomization.removed[option.id];
        }
      }
    } else {
      if (!option?.default) {
        if (!newProductCustomization?.added) {
          newProductCustomization.added = {};
          if (newProductCustomization.added[option?.id])
            newProductCustomization.added[option?.id] = option?.title;
        } else {
          newProductCustomization.added[option?.id] = option?.title;
        }
      } else {
        if (newProductCustomization?.removed) {
          delete newProductCustomization?.removed[option?.id];
        }
      }
    }
    dispatch(
      updateProductPayload({
        data: newProductCustomization,
      })
    );
    setRadioChecked(!check);
    setChecked(!check);
    subProductsGA(condimentsItems.title, selectedProduct.name);
  };

  const addDefaultCondiment = () => {
    if (disabled) {
      setAlertMessage(
        intl.formatMessage({ id: 'max_quantity_allowed_for_this_step' }, { count: maximum })
      );
      return;
    }

    let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

    if (isBundleItem) {
      if (
        !newProductCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[bundlePosition]?.[
          option.id
        ]
      ) {
        setNestedProperty(
          newProductCustomization,
          ['bundle', stepId, productID, 'items', bundlePosition, optionId],
          {}
        );
      }

      const nestedItems =
        newProductCustomization?.bundle?.[stepId]?.[productID]?.items?.[bundlePosition]?.[
          option.id
        ] || {};

      if (!newProductCustomization.bundle[stepId][productID]?.items) {
        newProductCustomization.bundle[stepId][productID]['items'] = {};
      }

      if (!newProductCustomization.bundle[stepId][productID]?.items?.[bundlePosition]) {
        newProductCustomization.bundle[stepId][productID]['items'][bundlePosition] = {};
      }

      if (
        !newProductCustomization.bundle[stepId][productID]?.items?.[bundlePosition]?.[option.id]
      ) {
        newProductCustomization.bundle[stepId][productID]['items'][bundlePosition][option.id] = {};
      }

      newProductCustomization.bundle[stepId][productID].items[bundlePosition][option.id] = {
        ...nestedItems,
        qty: (nestedItems?.qty ?? 0) + 1,
      };
    } else {
      if (!newProductCustomization?.items) {
        newProductCustomization['items'] = {};
      }
      if (!newProductCustomization.items?.[optionId]) {
        newProductCustomization.items[optionId] = {};
      }
      if (!newProductCustomization.items?.[optionId]?.[option.id]) {
        newProductCustomization.items[optionId][option.id] = {};
      }
      newProductCustomization.items[optionId][option.id]['qty'] =
        (newProductCustomization.items[optionId][option.id]?.qty || 0) + 1;
    }
    if (!option.default) {
      if (!newProductCustomization?.added) {
        newProductCustomization.added = {};
        newProductCustomization.added[option?.id] = option?.title;
      } else {
        newProductCustomization.added[option?.id] = option?.title;
      }
      if (newProductCustomization?.removed) {
        delete newProductCustomization.removed[option?.id];
      }
    } else {
      if (newProductCustomization?.removed) {
        delete newProductCustomization.removed[option?.id];
      }
    }
    // newProductCustomization.added = [...newProductCustomization.added, [option.title]];
    dispatch(
      updateProductPayload({
        data: newProductCustomization,
      })
    );
    setRadioChecked(-1);
  };

  const removeAllSubOptions = () => {
    let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

    if (isBundleItem) {
      if (
        !newProductCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[bundlePosition]?.[
          option.id
        ]
      ) {
        setNestedProperty(
          newProductCustomization,
          ['bundle', stepId, productID, 'items', bundlePosition, optionId],
          {}
        );
      }
      newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][option.id][
        'qty'
      ] = 0;
      delete newProductCustomization['bundle'][stepId][productID]['items'][bundlePosition][
        option.id
      ];
    } else {
      if (!newProductCustomization.items?.[optionId]) {
        newProductCustomization.items[optionId] = {};
      }
      if (!newProductCustomization.items[optionId][option.id]) {
        newProductCustomization.items[optionId][option.id] = {};
      }
      newProductCustomization.items[optionId][option.id]['qty'] = 0;
      delete newProductCustomization.items[optionId][option.id];
    }

    if (option?.default || defaultSubOptions?.length) {
      if (!newProductCustomization?.removed) {
        newProductCustomization.removed = {};
        newProductCustomization.removed[option.id] = option?.title;
      } else {
        newProductCustomization.removed[option?.id] = option?.title;
      }
      if (newProductCustomization?.added) {
        delete newProductCustomization.added[option?.id];
      }
    } else {
      if (newProductCustomization?.added) {
        delete newProductCustomization.added[option.id];
      }
    }

    dispatch(
      updateProductPayload({
        data: newProductCustomization,
      })
    );
    setRadioChecked(-1);
  };

  useEffect(() => {
    const defaultSelected = option?.subOptions?.reduce((acc, curr, idx) => {
      if (acc < 0 && curr.selected) {
        return idx;
      } else {
        return acc;
      }
    }, radioChecked);

    if (defaultSelected >= 0 && defaultSelected !== radioChecked) {
      setRadioChecked(defaultSelected);
    }
  }, [option.subOptions, radioChecked]);

  if (option.subOptions && option.subOptions?.length !== 0) {
    option.subOptions.forEach((condimentsItems, idx) => {
      const keyVal = `${idx}-ProductOption-${condimentsItems.product_id}-${condimentsItems.sku}`;

      const selected =
        (isBundleItem
          ? productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[bundlePosition]?.[
              option.id
            ]?.['qty']
          : productCustomization?.items?.[optionId]?.[option.id]?.['qty']) > 0;

      if (condimentsItems.default || (selected && idx == 0)) return;

      sub.push(
        <div className={css.toppingCheckboxContainer}>
          <Checkbox
            key={keyVal}
            checked={
              (isBundleItem
                ? productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[
                    bundlePosition
                  ]?.[option.id]?.['qty']
                : productCustomization?.items?.[optionId]?.[option.id]?.['qty']) > 1
                ? true
                : false
            }
            color="primary"
            id={id}
            edge="start"
            onChange={(event, value) =>
              handleChangeRadio(
                idx,
                condimentsItems,
                condimentsItems.selected == 1 ? 'unselect' : 'select'
              )
            }
          />
          <span className={css.toppingCheckboxTitle}>{condimentsItems.title}</span>
          <span className={css.toppingCheckboxPrice}>{`( +${decimalChecker(
            option?.subOptions[idx - 1]?.price
              ? condimentsItems.price - option?.subOptions[idx - 1]?.price
              : condimentsItems.price,
            decimalPoints
          )}${countryValidations.currency} )`}</span>
        </div>
      );
    });
  }
  const optionName = option.title;
  const imgUrl = option && option.assets && option.assets[0]?.src;
  return (
    <>
      <div className={css.main}>
        <ListItem button component="label" htmlFor={id} ContainerProps={{ className: css.root }}>
          <Avatar
            variant="square"
            alt={optionName}
            // src={`${imgBaseUrl.product}/${country}/${option.imageThumbnail}`}
            src={imgUrl}
            className={css.image}
          />
          <div className={css.title}>
            <div className={css.titleText}>
              <span className={css.titleTag}>{optionName}</span>
              {defaultSubOptions?.length > 0 && (
                <span className={css.defaultTag}>
                  <FormattedMessage id={'default'} defaultMessage={'DEFAULT'} />
                </span>
              )}
            </div>
            <div
              className={ClassNames(css.subItems, {
                [css.show]:
                  (isBundleItem
                    ? productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']?.[
                        bundlePosition
                      ]?.[option.id]?.['qty']
                    : productCustomization?.items?.[optionId]?.[option.id]?.['qty']) >= 1,
              })}
            >
              {sub}
            </div>
            {!isAnySubOptionSelected && !option?.selectionQty && (
              <ListItemText
                className={css.priceSpan}
                primary={`${
                  option?.price
                    ? '( ' +
                      decimalChecker(option?.price, decimalPoints) +
                      ' ' +
                      countryValidations.currency +
                      ')'
                    : ''
                }`}
              />
            )}
          </div>
          {!isAnySubOptionSelected && (
            <Button
              variant="outlined"
              color="info"
              size="small"
              className={css.checkbox}
              onClick={() => addDefaultCondiment()}
            >
              <FormattedMessage id="producttile_add" defaultMessage="Add" />
            </Button>
          )}
          {isAnySubOptionSelected && (
            <Button variant="outlined" className={css.less} onClick={() => removeAllSubOptions()}>
              <GrTrash />
            </Button>
          )}
        </ListItem>
      </div>
      {alertMessage && isDesktop && (
        <Snackbar
          open={alertMessage?.length > 0}
          autoHideDuration={6000}
          onClose={handleAlertClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={handleAlertClose} severity="error" sx={{ width: '100%' }}>
            {alertMessage}
          </Alert>
        </Snackbar>
      )}
      {alertMessage && !isDesktop && (
        <div onClick={handleAlertClose} className={css.alert}>
          {alertMessage}
        </div>
      )}
    </>
  );
}
